import { LokaliseKey, SupportedISOCode } from '../types/i18n';

export const FALLBACK_LANGUAGE: SupportedISOCode = 'en';
export const FALLBACK_LANGUAGE_MOCK: SupportedISOCode = 'en';
export const DEFAULT_LANGUAGE_MOCK: SupportedISOCode = 'en';

export const LOKALISE_KEYS: LokaliseKey[] = [
  {
    isoCode: 'es',
    lokaliseKey: 'language.spanish'
  },
  {
    isoCode: 'en',
    lokaliseKey: 'language.english'
  }
];

// The site is served in English only for now. Spanish translations are preserved in the repo
// for the future — uncomment the following line to re-enable it across the UI and i18n init.
// export const SUPPORTED_ISO_CODES: SupportedISOCode[] = Object.keys(SupportedISOCodes) as SupportedISOCode[];
export const SUPPORTED_ISO_CODES: SupportedISOCode[] = ['en'];

export const LANGUAGES_KEYS = {
  es: 'language.spanish',
  en: 'language.english'
};
